import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "side-bar__navigation text--align-center" }
const _hoisted_3 = { class: "side-bar--column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-home side-bar--column__item--icon" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Dashboard", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-id-badge side-bar--column__item--icon" }, null, -1)
const _hoisted_7 = { class: "side-bar--column__item--name" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-sitemap side-bar--column__item--icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Sites", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-play-circle side-bar--column__item--icon" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Subscriptions", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-dollar-sign side-bar--column__item--icon" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Billing", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-file-invoice-dollar side-bar--column__item--icon" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Invoice", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-user side-bar--column__item--icon" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Users", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-upload side-bar--column__item--icon" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Manual Uploads", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-globe side-bar--column__item--icon" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Mega Data", -1)
const _hoisted_22 = { key: 4 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "side-bar--column__item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ewebdata.clientseoreport.com/login",
      class: "fa fa-chart-line side-bar--column__item--icon"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Performance Analytics")
  ])
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", { class: "fa fa-question side-bar--column__item--icon" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "side-bar--column__item--name" }, "Support", -1)
const _hoisted_27 = { class: "toolbar--logo" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "toolbar--page__info ma--x-1 pa--y-1 text--size-1-2 text--weight-bold" }
const _hoisted_30 = { class: "btn--name" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "toolbar--spacer" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-briefcase btn--icon__prefix" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "App Params", -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "toolbar--announcement"
}
const _hoisted_36 = { class: "text--align-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { class: "toolbar--right" }
const _hoisted_39 = {
  key: 0,
  class: "dropdown ma--x-2 bottom left",
  "data-tooltip": "Toggle between sites."
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "color--primary-green text--style-italic text--size-1-1 text--align-left"
}
const _hoisted_42 = {
  key: 1,
  class: "color--primary text--style-italic text--size-1-1 text--align-left"
}
const _hoisted_43 = {
  key: 2,
  class: "color--primary text--style-italic text--size-1-1 text--align-left"
}
const _hoisted_44 = {
  key: 1,
  class: "text--align-center color--primary-red"
}
const _hoisted_45 = { class: "toolbar--right" }
const _hoisted_46 = {
  class: "toolbar--credits bottom",
  "data-tooltip": "Credits available for purchases."
}
const _hoisted_47 = { class: "notifications--icon__count" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "notifications--menu__header" }, "Notifications", -1)
const _hoisted_49 = {
  key: 0,
  class: "notifications--menu__content"
}
const _hoisted_50 = { class: "notifications--menu__item--icon" }
const _hoisted_51 = { class: "notifications--menu__item--message" }
const _hoisted_52 = { class: "notifications--menu__item--time" }
const _hoisted_53 = { class: "toolbar--dropdown dropdown" }
const _hoisted_54 = { class: "toolbar--dropdown__username" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user-circle" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-key" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sign-out-alt" }, null, -1)
const _hoisted_58 = { class: "display--flex overflow--hidden" }
const _hoisted_59 = { class: "content--wrapper" }
const _hoisted_60 = { class: "help--desk-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_alert = _resolveComponent("app-alert")!
  const _component_app_confirm = _resolveComponent("app-confirm")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_CreateUser = _resolveComponent("CreateUser")!
  const _component_ChangePassword = _resolveComponent("ChangePassword")!
  const _component_AppParams = _resolveComponent("AppParams")!
  const _component_SiteSubscription = _resolveComponent("SiteSubscription")!
  const _component_Help = _resolveComponent("Help")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["side-bar", { 'side-bar__small': !_ctx.sideBar, 'side-bar__large': _ctx.sideBar }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "fa fa-bars",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateSideBar && _ctx.updateSideBar(...args)))
          })
        ]),
        _createElementVNode("ul", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/dashboard",
            tag: "li",
            class: "side-bar--column__item",
            "active-class": "side-bar--column__item--active",
            exact: "",
            title: "Dashboard"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/leads",
            tag: "li",
            class: "side-bar--column__item",
            "active-class": "side-bar--column__item--active",
            title: "Leads"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/sites",
            tag: "li",
            class: "side-bar--column__item",
            "active-class": "side-bar--column__item--active",
            title: "Sites"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }),
          (_ctx.subscriptionMode)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/subscriptions",
                tag: "li",
                class: "side-bar--column__item",
                "active-class": "side-bar--column__item--active",
                title: "Subscriptions"
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.subscriptionMode)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/billing",
                tag: "li",
                class: "side-bar--column__item",
                "active-class": "side-bar--column__item--active",
                title: "Billing"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.subscriptionMode)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "/invoice",
                tag: "li",
                class: "side-bar--column__item",
                "active-class": "side-bar--column__item--active",
                title: "Invoice"
              }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _hoisted_15
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/users",
            tag: "li",
            class: "side-bar--column__item",
            "active-class": "side-bar--column__item--active",
            title: "Users"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _hoisted_17
            ]),
            _: 1
          }),
          (_ctx.store.getters.isSuperAdmin && _ctx.manualUpload)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                to: "/manual-upload",
                tag: "li",
                class: "side-bar--column__item",
                "active-class": "side-bar--column__item--active",
                title: "Manual Uploads"
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/megadata",
            tag: "li",
            class: "side-bar--column__item",
            "active-class": "side-bar--column__item--active",
            title: "Mega Data"
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              _hoisted_21
            ]),
            _: 1
          }),
          (_ctx.getAeroleadAnalyticsIcon())
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/support",
            tag: "li",
            class: "side-bar--column__item",
            "active-class": "side-bar--column__item--active",
            title: "Support"
          }, {
            default: _withCtx(() => [
              _hoisted_25,
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["toolbar", { toolbar__small: _ctx.sideBar, toolbar__large: !_ctx.sideBar }])
      }, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("img", {
            src: _ctx.logo,
            alt: "Lead Pulse",
            class: "toolbar--logo__img",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToHome()))
          }, null, 8, _hoisted_28)
        ]),
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.page), 1),
        (_ctx.siteSubscriptionAlreadyPresent)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass((!(_ctx.getSelectedSiteSubscriptionStatus() === '-EXPIRED'))? 'btn btn--primary' : 'btn btn--danger'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showActiveSubscription())),
              "data-tooltip": "Active Subscription."
            }, [
              _createElementVNode("span", _hoisted_30, "Active Subscription" + _toDisplayString(_ctx.getSelectedSiteSubscriptionStatus()), 1)
            ], 2))
          : _createCommentVNode("", true),
        _hoisted_31,
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn--primary bottom right",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editAppParams())),
              "data-tooltip": "Input Application Parameters."
            }, _hoisted_34))
          : _createCommentVNode("", true),
        (_ctx.announcement)
          ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToMegaData()))
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createTextVNode("Mega Data Available"),
                  _hoisted_37,
                  _createTextVNode(_toDisplayString(Number(_ctx.megaDataCount).toLocaleString()), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_38, [
          (_ctx.siteResponse.data && _ctx.siteResponse.data.length && _ctx.siteName)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", {
                  class: "dropdown-toggle",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sitesToggle = !_ctx.sitesToggle))
                }, _toDisplayString(_ctx.siteName), 1),
                _createElementVNode("ul", {
                  class: _normalizeClass(["dropdown-menu dropdown-menu__left", { show: _ctx.sitesToggle }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteResponse.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(["dropdown-item", { 'dropdown-item-active': _ctx.siteName == item.siteName }]),
                      key: index,
                      onClick: ($event: any) => (_ctx.updateSiteId(item))
                    }, [
                      (_ctx.hasSiteAvailableLeads(item))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, "leads available "))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.siteName), 1),
                      (_ctx.hasSiteAvailableLeads(item))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "(" + _toDisplayString(_ctx.getSiteAvailableLeads(item)) + ")", 1))
                        : _createCommentVNode("", true),
                      (_ctx.isActiveSubscriptionPresent(item))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, " - Active Subscription"))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_40))
                  }), 128))
                ], 2)
              ])), [
                [_directive_click_outside, _ctx.clickOutSideSite]
              ])
            : _createCommentVNode("", true),
          (!(_ctx.siteResponse.data && _ctx.siteResponse.data.length && _ctx.siteName))
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " No active projects "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToBiling()))
            }, "Available Credits: " + _toDisplayString(_ctx.formatNumber2Decimals(_ctx.selectedSiteCredits)), 1)
          ]),
          (_ctx.enableNotifications)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["notifications", {
              show: _ctx.showNotifications,
            }])
              }, [
                _createElementVNode("a", {
                  class: "fa fa-bell ma--right-4 notifications--icon",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (
                _ctx.notificationCount > 0
                  ? (_ctx.showNotifications = !_ctx.showNotifications)
                  : ''
              ))
                }, [
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.notificationCount >= 10 ? "!" : _ctx.notificationCount), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["notifications--menu notifications--menu__left", {
                show: _ctx.showNotifications,
              }])
                }, [
                  _hoisted_48,
                  (_ctx.notifications)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "notifications--menu__item",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa", {
                        'fa-download': item.type == 'READYTODOWNLOAD',
                        'fa-file-invoice': item.type == 'LEADSAVAILABLE',
                        'fa-id-badge': (item.type = 'SITEAPPROVED'),
                      }])
                              }, null, 2)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_51, _toDisplayString(item.message ? item.message : "No Message available"), 1),
                              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$filters.timeDisplay(item.timeinMillis)), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ], 2)), [
                [_directive_click_outside, _ctx.clickOutSideNotifications]
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", {
              class: "toolbar--dropdown__avator",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.userToggle = !_ctx.userToggle))
            }, _toDisplayString((_ctx.user.firstName == null)?"?":_ctx.user.firstName.charAt(0).toUpperCase()), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-menu dropdown-menu__left", { show: _ctx.userToggle }])
            }, [
              _createElementVNode("div", _hoisted_54, " Hi, " + _toDisplayString((_ctx.user.firstName == null)?"User":_ctx.user.firstName.substr(0,10)), 1),
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  class: "dropdown-item",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editProfile()))
                }, [
                  _hoisted_55,
                  _createTextVNode(" Edit Profile ")
                ]),
                _createElementVNode("li", {
                  class: "dropdown-item",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {
                    _ctx.userToggle = false;
                    _ctx.allowChangePassword = true;
                  })
                }, [
                  _hoisted_56,
                  _createTextVNode(" Change Password ")
                ]),
                _createElementVNode("li", {
                  class: "dropdown-item",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, [
                  _hoisted_57,
                  _createTextVNode(" Sign out ")
                ])
              ])
            ], 2)
          ])), [
            [_directive_click_outside, _ctx.clickOutSideUser]
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("main", {
      class: _normalizeClass(["content-page", { small__content: _ctx.sideBar, large__content: !_ctx.sideBar }])
    }, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          (_ctx.allow)
            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_app_alert, { ref: "alert" }, null, 512),
          _createVNode(_component_app_confirm, { ref: "confirm" }, null, 512),
          _createVNode(_component_AppFooter),
          (_ctx.toggleEditProfileModel)
            ? (_openBlock(), _createBlock(_component_CreateUser, {
                key: 1,
                accessType: "Edit Profile",
                data: _ctx.userRequest,
                onCloseModel: _ctx.onCloseProfileModel
              }, null, 8, ["data", "onCloseModel"]))
            : _createCommentVNode("", true),
          (_ctx.allowChangePassword)
            ? (_openBlock(), _createBlock(_component_ChangePassword, {
                key: 2,
                email: _ctx.user.email,
                onClosePassword: _ctx.onClosePassword
              }, null, 8, ["email", "onClosePassword"]))
            : _createCommentVNode("", true),
          (_ctx.toggleAppParamsModel)
            ? (_openBlock(), _createBlock(_component_AppParams, {
                key: 3,
                appResponse: this.appResponse,
                onClose: _ctx.onCloseAppParams
              }, null, 8, ["appResponse", "onClose"]))
            : _createCommentVNode("", true),
          (_ctx.toggleSiteSubscriptionModel)
            ? (_openBlock(), _createBlock(_component_SiteSubscription, {
                key: 4,
                activeSubscription: _ctx.selectedSiteSubscription,
                projectName: _ctx.siteName,
                siteId: _ctx.siteId,
                onClose: _ctx.onCloseSiteSubscription
              }, null, 8, ["activeSubscription", "projectName", "siteId", "onClose"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["help--desk", {
              'show--desk': _ctx.helpDesk,
              'hide--desk': !_ctx.helpDesk,
            }])
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn--primary help--desk__button", {
                'help--desk__button--active': _ctx.helpDesk,
              }]),
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateHelpDeskStatus && _ctx.updateHelpDeskStatus(...args))),
              title: "Click to expand."
            }, " Help ", 2),
            _createVNode(_component_Help, { currentPage: _ctx.page }, null, 8, ["currentPage"])
          ], 2)), [
            [_directive_click_outside, _ctx.clickOutSideHelpDesk]
          ])
        ])
      ])
    ], 2)
  ]))
}